import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Icon } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import Image from 'components/shared/Image/Image';
import { actions } from 'components/shared/attachmentsPreviewModal/actions/attachmentsPreviewModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import styles from './storyImage.module.scss';
export const StoryImage = ({ attachment: { url, pretty_name }, onError, }) => {
    const dispatch = useAppDispatch();
    const handlePreview = useCallback(() => {
        dispatch(actions.attachmentsPreviewModalOpen({
            fileName: pretty_name,
            url,
        }));
        analytics.conversationAttachedImageIsViewed();
    }, [dispatch, url, pretty_name]);
    return (_jsxs(Box, Object.assign({ className: styles.root, onClick: handlePreview }, { children: [_jsx(Image, { className: styles.image, src: url, alt: pretty_name, onErrorHandler: onError }), _jsx(Box, Object.assign({ className: styles.overlay }, { children: _jsx(Icon, { name: "eye", size: 24, color: colors.neutral['000'] }) }))] })));
};
